<template>
  <g transform="matrix(1,0,0,1,0,0)"
    ><path
      d="M1.500 11.250 A3.750 3.750 0 1 0 9.000 11.250 A3.750 3.750 0 1 0 1.500 11.250 Z"
      :style="[strokeStyle]"
      class="fill-none"
    ></path
    ><path
      d="M15.000 6.000 A3.750 3.750 0 1 0 22.500 6.000 A3.750 3.750 0 1 0 15.000 6.000 Z"
      :style="[strokeStyle]"
      class="fill-none"
    ></path
    ><path
      d="M15.000 18.000 A3.750 3.750 0 1 0 22.500 18.000 A3.750 3.750 0 1 0 15.000 18.000 Z"
      :style="[strokeStyle]"
      class="fill-none"
    ></path
    ><path
      d="M8.746 9.891L15.254 7.36"
      :style="[strokeStyle]"
      class="fill-none"
    ></path
    ><path
      d="M8.605 12.928L15.395 16.323"
      :style="[strokeStyle]"
      class="fill-none"
    ></path
  ></g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;

export default {
  name: "IconShare",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {},
};
</script>
